export default "__VITE_ASSET__5G3sr1Qe__"